import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigation = useNavigate();

  const { callApi, loading, error, data } = useApi("/api/forgotPassword", {
    method: "POST",
    autoCall: false,
  });
  const sendOtp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await callApi({ email: email });

      Swal.fire({
        icon: "success",
        title: "OTP sent successfully",
        text: response?.data?.message || "Please check your email to proceed.",
        showConfirmButton: true,
        timer: 1000,
        timerProgressBar: true,
        position: "center",
      });
      navigation(all_routes.emailVerification, { state: { email } });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        Swal.fire({
          icon: "error",
          title: "Failed to send OTP",
          text: err.response?.data?.message || "Please try again.",
          showConfirmButton: true,
          timer: 2500,
          timerProgressBar: true,
          position: "center",
        });
      }
    }
  };
  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          {/* Left Section with Video Background */}
          <div className="col-lg-7">
            <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
              <div className="bg-overlay-img">
                <ImageWithBasePath
                  src="/assets/img/bg/bg-01.png"
                  className="bg-1"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="/assets/img/bg/bg-02.png"
                  className="bg-2"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="/assets/img/bg/bg-03.png"
                  className="bg-3"
                  alt="Img"
                />
              </div>
              <div className="authentication-card-container">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="video-background"
                >
                  <source
                    src="/assets/img/video/team1ConsultingBannervideo.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>

          {/* Right Section with Forgot Password Form */}
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="login-form-container forgotPassword d-flex justify-content-center align-items-center vh-100">
              <div className="form-wrapper w-100 px-4">
                <form className="rounded" onSubmit={sendOtp}>
                  <div className="text-center mb-4">

                    <div className="logo-wrapper mx-auto" style={{ maxWidth: "130px" }}>
                      <ImageWithBasePath
                        src="/assets/img/logo/team1-consultancy1.png"
                        className="img-fluid logo-img"
                        alt="Logo"
                      />
                    </div>
                    <div className="logo-wrapper mx-auto" style={{ maxWidth: "180px" }}>
                      <ImageWithBasePath
                        src="/assets/img/logo/weconnectlogo.png"
                        className="img-fluid logo-img"
                        alt="Logo"
                      />
                    </div>
                  </div>


                  <div className="text-center mb-3">
                    <h2 className="mb-2">Forgot Password?</h2>
                    <p className="mb-0 text-muted">
                      Please enter your email address. You will receive an email message with instructions on how to reset your password.
                    </p>
                  </div>

                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type="email"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          setEmail(e.target.value)
                        }
                        className="form-control border-end-0"
                        required
                        placeholder="Email Address"
                      />
                      <span className="input-group-text border-start-0">
                        <i className="ti ti-mail" />
                      </span>
                    </div>
                  </div>

                  <div className="mb-4 mt-2">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Submit"}
                    </button>
                  </div>

                  <div className="text-center">
                    <h6 className="fw-normal text-dark mb-0">
                      Return to
                      <Link to={all_routes.login} className="hover-a ms-1">
                        Sign In
                      </Link>
                    </h6>
                  </div>
                </form>

                <div className="text-center text-gray-9 mt-5">
                  © {new Date().getFullYear()} WeConnect. All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default ForgotPassword;




// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import ImageWithBasePath from "../../../core/common/imageWithBasePath";
// import useApi from "../../../core/customhook/useApi";
// import Swal from "sweetalert2";
// import axios from "axios";

// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");
//   const navigation = useNavigate();

//   const { callApi, loading, error, data } = useApi("/api/forgotPassword", {
//     method: "POST",
//     autoCall: false,
//   });
//   const sendOtp = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     try {
//       const response = await callApi({ email: email });

//       Swal.fire({
//         icon: "success",
//         title: "OTP sent successfully",
//         text: response?.data?.message || "Please check your email to proceed.",
//         showConfirmButton: true,
//         timer: 1000,
//         timerProgressBar: true,
//         position: "center",
//       });
//       navigation(all_routes.emailVerification, { state: { email } });
//     } catch (err) {
//       if (axios.isAxiosError(err)) {
//         Swal.fire({
//           icon: "error",
//           title: "Failed to send OTP",
//           text: err.response?.data?.message || "Please try again.",
//           showConfirmButton: true,
//           timer: 2500,
//           timerProgressBar: true,
//           position: "center",
//         });
//       }
//     }
//   };
//   return (
//     <div className="container-fuild">
//       <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
//         <div className="row">
//           <div className="col-lg-5">
//             <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
//               <div className="bg-overlay-img">
//                 <ImageWithBasePath
//                   src="assets/img/bg/bg-01.png"
//                   className="bg-1"
//                   alt="Img"
//                 />
//                 <ImageWithBasePath
//                   src="assets/img/bg/bg-02.png"
//                   className="bg-2"
//                   alt="Img"
//                 />
//                 <ImageWithBasePath
//                   src="assets/img/bg/bg-03.png"
//                   className="bg-3"
//                   alt="Img"
//                 />
//               </div>
//               <div className="authentication-card w-100">
//                 <div className="authen-overlay-item border w-100">
//                   <h1 className="text-white display-1">
//                     {/* Empowering people <br /> through seamless HR <br /> management. */}
//                     WeConnect: Uniting teams, streamlining human resource.
//                   </h1>
//                   <div className="my-4 mx-auto authen-overlay-img">
//                     <ImageWithBasePath
//                       src="assets/img/weconnect_login.png"
//                       alt="Img"
//                     />
//                   </div>
//                   <div>
//                     <p className="text-white fs-20 fw-semibold text-center">
//                       Efficiently manage your workforce, streamline <br />{" "}
//                       operations effortlessly.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-7 col-md-12 col-sm-12">
//             <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
//               <div className="col-md-7 mx-auto vh-100">
//                 <form className="vh-100" onSubmit={sendOtp}>
//                   <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
//                     <div className="mx-auto mb-5 text-center">
//                       <ImageWithBasePath
//                         src="/assets/img/logo/weconnectlogo.png"
//                         className="img-fluid"
//                         alt="Logo"
//                       />
//                     </div>

//                     <div>
//                       <div className="text-center mb-3">
//                         <h2 className="mb-2">Forgot Password?</h2>
//                         <p className="mb-0">
//                           If you forgot your password, well, then we'll email
//                           you instructions to reset your password.
//                         </p>
//                       </div>

//                       <div className="mb-3">
//                         <label className="form-label">Email Address</label>
//                         <div className="input-group">
//                           <input
//                             type="email"
//                             onChange={(
//                               e: React.ChangeEvent<HTMLInputElement>
//                             ) => setEmail(e.target.value)}
//                             className="form-control border-end-0"
//                             required
//                           />
//                           <span className="input-group-text border-start-0">
//                             <i className="ti ti-mail" />
//                           </span>
//                         </div>
//                       </div>

//                       <div className="mb-3">
//                         <button
//                           type="submit"
//                           className="btn btn-primary w-100"
//                           disabled={loading}
//                         >
//                           {loading ? "Sending OTP..." : "Submit"}
//                         </button>
//                       </div>

//                       <div className="text-center">
//                         <h6 className="fw-normal text-dark mb-0">
//                           Return to
//                           <Link to={all_routes.login} className="hover-a ms-1">
//                             Sign In
//                           </Link>
//                         </h6>
//                       </div>
//                     </div>

//                     <div className="mt-5 pb-4 text-center">
//                       <p className="mb-0 text-gray-9">
//                          © {new Date().getFullYear()} WeConnect. All rights reserved.
//                       </p>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
